// import { createApp } from './main'

console.log('what !')
// export default (context) => {
//   const { app } = createApp()
//   return app
// }
// module.exports = {
//   aaa: 123
// }

export const aaa = 123